import { domainRegistry } from "#schemas/registry.ts";
import { z } from "zod";

/** "#RRGGBB" exactly. Empty string is NOT valid here — see OptionalHexColorSchema. */
export const HexColorSchema = z
  .string()
  .regex(/^#[0-9A-Fa-f]{6}$/, "expected #RRGGBB")
  .register(domainRegistry, {
    id: "hex_color",
    title: "Hex color",
    description: "Six-digit hex color (#RRGGBB).",
    surface: "store",
    llmExposed: true,
    persistKey: "color",
    group: "tools",
    examples: ["#C08050", "#000000", "#FFFFFF"],
  });
export type HexColor = z.infer<typeof HexColorSchema>;

/** Color slot allowing the empty-string transparent sentinel. Used by pxpf. */
export const OptionalHexColorSchema = z.union([z.literal(""), HexColorSchema])
  .register(domainRegistry, {
    id: "optional_hex_color",
    title: "Optional hex color",
    description: "Hex color or empty string for transparent.",
    surface: "pxpf",
    llmExposed: false,
    group: "pxpf",
  });
export type OptionalHexColor = z.infer<typeof OptionalHexColorSchema>;

export const FpsSchema = z.int().min(1).max(60).register(domainRegistry, {
  id: "fps",
  title: "Frames per second",
  description: "Animation playback rate. Integer in [1, 60].",
  surface: "store",
  llmExposed: true,
  persistKey: "fps",
  group: "playback",
  examples: [12, 24, 30],
});
export type Fps = z.infer<typeof FpsSchema>;

export const OnionOpacitySchema = z.number().min(0).max(1).register(domainRegistry, {
  id: "onion_opacity",
  title: "Onion-skin opacity",
  description: "Alpha for previous-frame ghost overlay. 0..1.",
  surface: "store",
  llmExposed: true,
  persistKey: "onionOpacity",
  group: "playback",
  examples: [0.0, 0.35, 0.75],
});
export type OnionOpacity = z.infer<typeof OnionOpacitySchema>;

export const ProjectNameSchema = z.string().min(1).max(255).register(domainRegistry, {
  id: "project_name",
  title: "Project name",
  description: "Human-readable project name. Non-empty, max 255 chars.",
  surface: "store",
  llmExposed: true,
  persistKey: "projectName",
  group: "project",
  examples: ["Untitled", "Hero Sprite v2"],
});
export type ProjectName = z.infer<typeof ProjectNameSchema>;

export const NonNegIntSchema = z.int().min(0);
export const PositiveIntSchema = z.int().positive();
